import React from "react";
import styled, { css } from "styled-components";
import { useInView } from "../../../hooks";
import { easing, media } from "../../../theme";

const hiddenTransforms = {
  up: "translate3d(0, 2rem, 0)",
  left: "translate3d(-2.5rem, 0, 0)",
  right: "translate3d(2.5rem, 0, 0)",
  scale: "scale(0.96)",
  none: "none",
};

const Wrapper = styled.div`
  opacity: ${({ $visible }) => ($visible ? 1 : 0)};
  transform: ${({ $visible, $from }) =>
    $visible ? "none" : hiddenTransforms[$from]};
  transition: opacity ${({ $duration }) => $duration}s ${easing.out},
    transform ${({ $duration }) => $duration}s ${easing.out};
  transition-delay: ${({ $delay }) => $delay}s;

  ${media.mobile} {
    ${({ $visible, $from }) =>
      !$visible &&
      ($from === "left" || $from === "right") &&
      css`
        transform: ${hiddenTransforms.up};
      `}
  }
`;

// Fades its children in (optionally sliding from a direction) the first time
// they scroll into view.
const Reveal = ({ children, from = "up", delay = 0, duration = 0.8, ...rest }) => {
  const [ref, inView] = useInView();

  return (
    <Wrapper
      ref={ref}
      $visible={inView}
      $from={from}
      $delay={delay}
      $duration={duration}
      {...rest}
    >
      {children}
    </Wrapper>
  );
};

export default Reveal;
